import SettingsImage from './settings-image';

export default SettingsImage;
